import { bannerTypeMap } from '@/map/banner'

export default [
  {
    key: 'id',
    type: 'id',
  },
  {
    key: 'order',
    label: 'Urutan',
    type: 'number',
    sortable: true,
  },
  {
    key: 'image',
    type: 'image',
    label: 'Banner',
  },
  {
    key: 'name',
    label: 'Nama',
  },
  {
    key: 'link',
    type: 'url',
  },
  {
    key: 'type',
    label: 'Tipe',
    type: 'badge',
    map: bannerTypeMap,
    filter: {
      key: 'type',
      type: 'select',
      options: [
        { value: 'direct', text: 'Direct' },
        { value: 'page', text: 'Page' },
      ],
    },
  },
  {
    key: 'active',
    label: 'Status',
    filter: {
      key: 'active',
      type: 'select',
      label: 'Status',
      options: [
        { value: true, text: 'Aktif' },
        { value: false, text: 'Tidak aktif' },
      ],
    },
  },
]
